import { MapUiTheme } from '../../common';

export const tableTheme = {
  table: {
    borderRadius: (theme: any) => theme.spacing[3],
    boxShadow: (theme: any) => theme.boxShadow.lg,
    marginBottom: (theme: any) => theme.spacing[5],
    borderSpacing: '0',
  },
  fullWidth: {
    width: '100%',
  },
  header: {
    color: (theme: MapUiTheme) => theme.colors.white,
    backgroundColor: (theme: MapUiTheme) => theme.colors.text300,

    'tr th': {
      padding: (theme: any) => theme.spacing[3],
      fontWeight: (theme: MapUiTheme) => theme.fontWeight.normal,
      textAlign: 'right',
    },

    'tr:first-of-type th:first-of-type': {
      borderTopLeftRadius: '12px',
    },

    'tr:last-of-type th:last-of-type': {
      borderTopRightRadius: '12px',
    },
  },
  headerCell: {
    sortable: {
      cursor: 'pointer',
    },
  },
  body: {
    textAlign: 'right',

    'tr td': {
      padding: (theme: any) => theme.spacing[3],
      fontWeight: (theme: MapUiTheme) => theme.fontWeight.normal,
    },

    'tr:nth-of-type(even)': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.grey200,
    },
    'tr:nth-of-type(odd)': {
      backgroundColor: (theme: MapUiTheme) => theme.colors.white,
    },
  },
  footer: {
    backgroundColor: (theme: MapUiTheme) => theme.colors.text300,
    color: (theme: MapUiTheme) => theme.colors.white,
    textalign: 'right',

    'tr td': {
      padding: '8px 14px',
      fontWeight: (theme: MapUiTheme) => theme.fontWeight.normal,
    },

    'tr:first-of-type td:first-of-type': {
      borderBottomLeftRadius: '12px',
    },
    'tr:last-of-type td:last-of-type': {
      borderBottomRightRadius: '12px',
    },
  },
  sorting: {
    cursor: 'pointer',
    marginLeft: '6px',
  },
  pagination: {
    display: 'inline-block',
    '.__mapui_icon': {
      color: (theme: MapUiTheme) => `${theme.colors.white} !important`,
      fill: (theme: MapUiTheme) => `${theme.colors.white} !important`,
    },
    '.__mapui_select': {
      borderRadius: '6px',
    },
  },
};
